 
import React from "react";
import { StandadCard } from "../../../../../../components/Cards";
import {
  AccountCircle,
  AdminPanelSettings,
  ManageAccounts,
} from "@mui/icons-material";
import { TabPanel } from "../../../../../../components/Tabs/TabPanel";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { PageLoader } from "../../../../../../components/PageLoader/PageLoader";
import { LoadState, MODULE_IDS } from "../../../../../../constants/enums";
import { useDispatchWrapper } from "../../../../../../hooks";
import { clearCustomerPolicyDetailsState } from "../../../../../../redux/customerPolicyDetails/customerPolicyDetailsActions";
import { AutomobilePriorPolicy } from "./PriorPolicy/PriorPolicy";
import { AutomobileCustomerInfo } from "./CustomerInfo/CustomerInfo";

import { TabsList } from "../../../../../../components/Tabs/TabsList";
import { useParams } from "react-router-dom";
import { AutomobilePolicyAdminManager } from "./PolicyAdminManager/PolicyAdminManager";
import { usePremissions } from "../../../../../../security/PremissionsProvider/PremissionsProvider";
import { TabsUncontrolledProvider } from "../../../../../../contexts/TabsContextProvider/TabsContextUncontrolledProvider";
import { PageContainer } from "../../../../../../components/container/PageContainer";

export const AutomobileBasicDetails = () => {
  const { customerId, customerPolicyId } = useParams() as {
    customerId?: number;
    customerPolicyId?: number;
  };
  const [tab, setTab] = React.useState(0);
  // The merged customer-policy-details fetch is dispatched by the CustomerInfo
  // child via useCustomerPolicyDetails. This parent only observes the shared
  // slice for loading/error and the saved id used to gate the dependent tabs.
  const { details: customerInfo, customerPolicyId: mergedCustomerPolicyId } =
    useSelector((storeState: IStoreState) => storeState.customerPolicyDetails);
  const dispatch = useDispatchWrapper();

  // When opening the "create new policy" screen (no customerPolicyId in the
  // URL), reset the shared merged slice on mount so a previously-opened
  // policy's id/details don't leak into the new-policy form. Without this, the
  // stale `mergedCustomerPolicyId` below would resolve to the old policy id.
  React.useEffect(() => {
    if (!customerPolicyId) {
      dispatch(clearCustomerPolicyDetailsState());
    }
     
  }, [customerPolicyId]);

  // Prefer the URL id; only fall back to the merged slice id after a new
  // policy has been saved in this session (URL id still absent, slice now
  // holds the freshly-created id).
  const savedCustomerPolicyId = customerPolicyId ?? mergedCustomerPolicyId;
  const { premissionsList } = usePremissions();
  const showAdminManager = premissionsList.find((x) => {
    if (
      x.module_key === MODULE_IDS.AUTO_POLICY_ADMIN_MANAGER &&
      x.show_module
    ) {
      return true;
    }
    return false;
  });

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  const changeStep = (newStep: number) => {
    setTab(newStep);
  };

  if (!customerId) {
    return null;
  }

  return (
     <PageContainer title="Basic Details" description="this is inner page">
    <PageLoader
      loading={customerInfo.loading === LoadState.InProgress}
      error={customerInfo.error ? { message: customerInfo.error } : null}
    >
      <TabsUncontrolledProvider step={tab} changeStep={changeStep}>
        <TabsList
          sx={{ mb: 1 }}
          varaint="fullWidth"
          selectedTab={tab}
          tabs={[
            { label: "Customer Info", icon: <AccountCircle /> },
            // {
            //   label: "Insurer Contact",
            //   icon: <Contacts />,
            //   disabled: !savedCustomerPolicyId,
            // },
            {
              label: "Prior Policy & NPC",
              icon: <AdminPanelSettings />,
              disabled: !savedCustomerPolicyId,
            },
            // {
            //   label: "Policy Admin",
            //   icon: <StickyNote2 />,
            //   disabled: !savedCustomerPolicyId,
            // },

            {
              label: "Policy Admin Manager",
              icon: <ManageAccounts />,
              hidden: !showAdminManager,
              disabled: !savedCustomerPolicyId,
            },
            // {
            //   label: "Premium",
            //   icon: <Receipt />,
            //   disabled: !savedCustomerPolicyId,
            // },
          ]}
          onChange={handleChange}
        />
        <StandadCard>
          <TabPanel value={tab} index={0}>
            <AutomobileCustomerInfo
              customerPolicyId={savedCustomerPolicyId}
              customerId={customerId}
            />
          </TabPanel>
          {savedCustomerPolicyId && (
            <>
              {/* <TabPanel value={tab} index={1}>
                <AutomobileAdditioanlInsured
                  customerpolicyId={savedCustomerPolicyId}
                />
              </TabPanel> */}
              <TabPanel value={tab} index={1}>
                <AutomobilePriorPolicy
                  customerpolicyId={savedCustomerPolicyId}
                />
              </TabPanel>

              {/* <TabPanel value={tab} index={2}>
                <AutomobilePolicyAdmin
                  customerpolicyId={savedCustomerPolicyId}
                />
              </TabPanel> */}

              <TabPanel value={tab} index={2}>
                <AutomobilePolicyAdminManager
                  customerpolicyId={savedCustomerPolicyId}
                />
              </TabPanel>
              {/* <TabPanel value={tab} index={4}>
                <AutomobilePremium customerpolicyId={savedCustomerPolicyId} />
              </TabPanel> */}
            </>
          )}
        </StandadCard>
      </TabsUncontrolledProvider>
    </PageLoader>
    </PageContainer>
  );
};
